enum Category {
  Paleta = "paletas",
  Recipiente = "recipientes",
  Postre = "postres"
}

export default Category;